module.exports = __webpack_public_path__ + "static/1-asset-4-d@3x-5b464c47af3152e6aa1cac064a385ae6.png";